//common script asset
var winSc;
var winW;
var winH;
var $window = $(window);
var slow =  'Expo.easeOut'
var power2 = "power2.out";
  
//init();
scrEve();
topbtnJs();
dwbtnJs();


function scrEve() {

    var lastScrollTop = 0;

    $(window).scroll(function(){
      
      //탑버튼 등장조건 100px이상 스크롤 시
      if ($(window).scrollTop() > 20) {
        $(".mouse-scr-bx").addClass("active");

      } else {
        $(".mouse-scr-bx").removeClass("active");
      }

      //gnb ui event fn
      var st = $(this).scrollTop();
      if (st > lastScrollTop){
           hideGnb()

      } else if  (st < 50 ) {      
           initGnb();
      
      } else {
            showGnb();

      }

      lastScrollTop = st;   
      

      
  });
  

}



function dwbtnJs() {

  var $dwBtn  = $(".dwlink");  
  var $outlinkBtn  = $(".outlink");

    var $sidebarBtnMocall  = $(".prd-sidebar .mo-uibtn");

  var $prdsidebarBtn  = $(".prd-sidebar");
  var $cmcsidebarBtn  = $(".common-sidebar");

  var $cmOutlinkBtn  = $(".outlinkbtn");

$sidebarBtnMocall.click(function() {

  if( $(this).hasClass("active") )  {
      $(".mo-viewx").removeClass("active"); 
      $sidebarBtnMocall.removeClass("active");

  } else {
      $(".mo-viewx").addClass("active");
      $sidebarBtnMocall.addClass("active");
  }
  
  
});


  $(window).scroll(function () {
    var $scTc = $(window).scrollTop();
    //console.log( $scT)

    //if (  $(window).height() / 2 < $scTc ) {

    if (  $(window).height()  < $scTc ) {
      //$dwBtn.addClass("active");
  	  //$outlinkBtn.addClass("active");
      //$cmOutlinkBtn.addClass("active")
      $prdsidebarBtn.addClass("active")
      $cmcsidebarBtn.addClass("active")
      

    } else {
      //$dwBtn.removeClass("active");
      //$outlinkBtn.removeClass("active");
      //$cmOutlinkBtn.removeClass("active")
      $prdsidebarBtn.removeClass("active")
      $cmcsidebarBtn.removeClass("active")

    }


  });
}




function topbtnJs() {

  var $topBtn  = $(".topbtn");


  $topBtn.click(function (){
    TweenMax.to( $("html"), 0.6, 
                { scrollTop : 0 ,  ease: Expo.ease}
               ); 
  });
  $topBtn.removeClass("active");

  $(window).scroll(function () {
    var $scT = $(window).scrollTop();
    //console.log( $scT)
    if (  $(window).height() < $scT ) {
      $topBtn.addClass("active");


    } else {
      $topBtn.removeClass("active");
    }


  });
}



function showGnb() {
  $("#SiteHeader").addClass("site-header--stuck");
  $("#SiteHeader").addClass("site-header--opening")
  $("#SiteHeader").removeClass("is-light");
  $("#HeaderWrapper").addClass("header-wrapper--sticky");
  $("#HeaderWrapper").removeClass("is-light");
  $("#SiteHeader").attr("data-sticky", "true");
}

function hideGnb() {
  $("#SiteHeader").removeClass("site-header--stuck");
  $("#SiteHeader").removeClass("site-header--opening");
  //$("#SiteHeader").addClass("is-light");
  $("#SiteHeader").attr("data-sticky", "false");
}

function initGnb() {
  $("#SiteHeader").removeClass("site-header--stuck");
  $("#SiteHeader").removeClass("site-header--opening");
  //$("#SiteHeader").addClass("is-light");
  $("#HeaderWrapper").addClass("header-wrapper--sticky")
  //$("#HeaderWrapper").addClass("is-light");
  $("#SiteHeader").attr("data-sticky", "false");
}






// ClassNamePlugin START (requires GSAP 3.2.2 or later)
gsap.registerPlugin({
  name: "className",
  init: true,
  register(gsap, Plugin) {
    var CSSPlugin = gsap.plugins.css,
      cssCore = CSSPlugin.core || console.warn("Requires GSAP 3.2.1 or later") || {},
      _removeLinkedListItem = gsap.core._removeLinkedListItem,
      _removeProperty = cssCore._removeProperty,
      PropTween = gsap.core.PropTween,
      _getAllStyles = function(target, uncache) {
        var styles = {},
          computed = getComputedStyle(target),
          cache = target._gsap,
          p;
        for (p in computed) {
          if (isNaN(p) && p !== "cssText" && p !== "length") {
            styles[p] = computed[p];
          }
        }
        uncache && cache && (cache.uncache = true);
        gsap.getProperty(target, "x"); 
        cache = target._gsap;
        for (p in cache) {
          styles[p] = cache[p];
        }
        return styles;
      };
    Plugin.prototype.init = function(target, endValue, tween) {
      let startClassList = target.getAttribute("class"),
        style = target.style,
        cssText = style.cssText,
        cache = target._gsap,
        classPT = cache.classPT,
        inlineToRemoveAtEnd = {},
        end = (endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : ""),
        plugin = this,
        changingVars = {},
        startVars = _getAllStyles(target),
        transformRelated = /(transform|perspective)/i,
        css = new CSSPlugin(),
        _renderClassName = function(ratio) {
          css.render(ratio, css);
          if (!ratio || ratio === 1) {
            target.setAttribute("class", ratio ? end : startClassList);
            for (var p in inlineToRemoveAtEnd) {
              _removeProperty(target, p);
            }
          }
        },
        endVars, p;
      if (classPT) {
        classPT.r(1, classPT.d);
        _removeLinkedListItem(classPT.d, classPT, "_pt");
      }
      target.setAttribute("class", end);
      endVars = _getAllStyles(target, true);
      target.setAttribute("class", startClassList);
      for (p in endVars) {
        if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
          changingVars[p] = endVars[p];
          if (!style[p] && style[p] !== "0") {
            inlineToRemoveAtEnd[p] = 1;
          }
        }
      }
      cache.classPT = plugin._pt = new PropTween(null, target, "className", 0, 0, _renderClassName, plugin, 0, -11);
      if (style.cssText !== cssText) {
        style.cssText = cssText; 
      }
      cache.uncache = true;
      gsap.getProperty(target, "x"); 
      css.init(target, changingVars, tween);
      plugin._props.push.apply(plugin._props, css._props);
      return 1;
    };
  }
});
// ClassNamePlugin END



$(document).ready(function () {

    var winW = $(window).width();
    var winH = $(window).height();
    scrollEv();



    function scrollEv() {


      var $jsScrSec = $(".js-scr-sec"); 
      //js-scr-sec - 패럴럭스 효과 시작 박스 / 하위 js-scr-box 와 셋트

      winSc =  $window.scrollTop();
      function scrollEvent() {
        $window.scroll(function () {
            winSc = $(this).scrollTop();

            scrollMotion(winSc);


            $(".pall_bg").each(function () {
                var offset = $(this).offset();
                var offsetTop = offset.top;
                var _this_h = $(this).innerHeight();
                var _calcPs = (winSc - offsetTop) / _this_h * 10;
                var _calcRsPs = _calcPs + 50;

                TweenMax.to($(this), 0.3, 
                  { "background-position-y" : _calcRsPs + "%",
                    ease: Expo.ease
                  }
                ); 

            });


        });

        $jsScrSec.each(function(){
            let _thisR = $(this);
            let secTop = _thisR.offset().top;
            let secInner = secTop - (winH / 2) - 250;
            scrInnerStep.push([_thisR,secInner]);
        });

		//console.log( scrInnerStep (index, v) )
        function scrollMotion(_winSc) {

            $.each(scrInnerStep, function (i, v) {
              
                if (_winSc >= v[1]) {
                  
                                //console.log( v[0].child(".js-scr-box") )


                    if (v[0].motion == undefined) {
                      
                      //console.log( 'position:' + v[1] )
                      //console.log( 'sec:' + v[0].find(".js-scr-box") )

                        gsap.to(v[0].find(".js-scr-box"), {
                          className:'+=js-motion-end',
                          delay: 0.8,
                          repeat: -1,
                          yoyo: false,
                          repeatDelay: 2,
                          duration: 1,
                        });
                      
                      

                      
                        v[0].motion = true;
                    }
                }
            });
        }
        scrollMotion(winSc)

      }

      scrollEvent();








    }


  
  
});   



var scrInnerStep = []; //각 페이지의 js-scr-sec 위치 저장


